import React, { useRef, useEffect } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { publish } from '_ui-core-js/utilities/events.js';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities/fireGTMTrackingEvent.js';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { RANGE_GTM_TRACKING_VALUES } from '../../../../../../range/ui/constants/analytics.js';

export function ColorOption(props) {

  const {
    color, 
    index, 
    block, 
    updateDisplayName, 
    active,
    modelName,
    baseModelName
  } = props;

  const tabRef = useRef();

  function dispatchUpdateColorEvent(event, index) {
    event.stopPropagation();

    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.componentEvent,
      componentName: baseModelName ? RANGE_GTM_TRACKING_VALUES.componentName.gradeRange + '-' + baseModelName : RANGE_GTM_TRACKING_VALUES.componentName.modelRange,
      componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      action: RANGE_GTM_TRACKING_VALUES.action.selectExteriorColour + '-' + color.name,
      label: modelName
    })

    publish('kc-vehicle-configurator-update', { 
      option: 'colors', 
      index
    });
  };

  useEffect(() => {
    if (active) {
      tabRef.current.focus();
      setTimeout(() => {
        tabRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }, 500);
    }
  }, [active]);

  return (
    <button 
    ref={tabRef}
    className={
      classNames({
        [`${block}__option-value-tab`]: true,
        [`${block}__option-value-tab--color`]: true,
        [`${block}__option-value-tab--active`]: active
      })
    }
    onClick={e => dispatchUpdateColorEvent(e, index)} 
    onMouseEnter={() => updateDisplayName(index)} 
    onMouseLeave={updateDisplayName}
    >
      <span className={`${block}__option-value-tab-inner`} style={{backgroundColor: `#${color.rgb}`}}></span>
    </button>
  )
};

ColorOption.propTypes = {
  color: propTypes.object.isRequired,
  index: propTypes.number.isRequired,
  block: propTypes.string.isRequired,
  updateDisplayName: propTypes.func.isRequired,
  modelName: propTypes.string,
  baseModelName: propTypes.string,
  active: propTypes.bool
};

ColorOption.defaultProps = {
  active: false
};